var map = {
	"./close.svg": 9964,
	"./del.svg": 3511,
	"./icon.svg": 1875,
	"./menu1.svg": 3174,
	"./menu2.svg": 9813,
	"./menu3.svg": 9447,
	"./menu4.svg": 9531,
	"./menu5.svg": 714,
	"./menubg.svg": 6448,
	"./msg.svg": 5459,
	"./preview.svg": 5484,
	"./set.svg": 8152,
	"./upload.svg": 9027,
	"./user.svg": 681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;